export default "__VITE_ASSET__46b8de85__"